<template>
    <div>
        <Header modeType="1" />
        <!-- getCrumbs.length为0时，不显示面包屑导航 -->
        <!-- <Crumbs v-show="getHasCrumbs && getCrumbs.length" /> -->
        <!-- 有面包屑导航的时候添加class content-has-crumbs是为了控制有无面包屑导航时的页面最小高度 -->
        <div class="content">
            <router-view/>
        </div>
        <Footer/>
    </div>
</template>

<script>
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default {
    name: 'App',
    components: {
        Header,
        Footer,
    },
    directives: {},
    data() {
        return {}
    },
    computed: {
        getHasCrumbs() {
            return this.$store.state.Breadcrumb.hasCrumbs
        }
    },
    mounted() {
    },
    methods: {}
}
</script>

<style lang="lass" scoped>
/* .content {
  min-height: call(100vh-72px-60px);
}
.content-has-crumbs {
  min-height: call(100vh-72px-60px-30px);
} */
</style>
